import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["arrivalDate", "departureDate", "form"]

  connect() {
    this.updateFormDates()
  }

  // Called when dates change (from datepicker or other sources)
  updateFormDates() {
    const arrivalDate = this.arrivalDateTarget?.value || ""
    const departureDate = this.departureDateTarget?.value || ""

    // Update all booking forms with the current dates
    this.formTargets.forEach(form => {
      this.injectDatesIntoForm(form, arrivalDate, departureDate)
    })
  }

  injectDatesIntoForm(form, arrivalDate, departureDate) {
    // Find or create hidden fields for arrival_date
    let arrivalField = form.querySelector('input[name="order_item[fulfillment_data][arrival_date]"]')
    if (!arrivalField) {
      arrivalField = document.createElement('input')
      arrivalField.type = 'hidden'
      arrivalField.name = 'order_item[fulfillment_data][arrival_date]'
      form.appendChild(arrivalField)
    }
    arrivalField.value = arrivalDate

    // Find or create hidden fields for departure_date
    let departureField = form.querySelector('input[name="order_item[fulfillment_data][departure_date]"]')
    if (!departureField) {
      departureField = document.createElement('input')
      departureField.type = 'hidden'
      departureField.name = 'order_item[fulfillment_data][departure_date]'
      form.appendChild(departureField)
    }
    departureField.value = departureDate
  }

  // This can be called from the datepicker when dates change
  datesChanged() {
    this.updateFormDates()
  }
}